import * as React from 'react';
import { observer } from 'mobx-react';
import { DetailsList, CheckboxVisibility } from 'office-ui-fabric-react/lib/DetailsList';
import { DiagnosticsInspector } from './DiagnosticsInspector';

const styles = require('./TwoColumnInspector.scss');

export interface TwoColumnItem<R> {
    row: R;
    details: any;
}

export interface TwoColumnInspectorProps<R> {
    items: TwoColumnItem<R>[];
    columns?: {
        key: keyof R & string;
        name: string;
        minWidth: number;
    }[];
}

export interface TwoColumnInspectorState {
    selected: any;
}

/**
 * Shows a two-column layout for inspecting log lines, with each item
 * in the inspected table showing a row in a chronlogical table.
 * When clicked, the second column shows an object inspector of the
 * associated details object.
 */
@observer
export class TwoColumnInspector<R> extends React.Component<
    TwoColumnInspectorProps<R>,
    TwoColumnInspectorState
> {
    constructor(props: TwoColumnInspectorProps<R>) {
        super(props);

        this.state = {
            selected: null,
        };
    }

    changeSelected = row => {
        let selectedItem = this.props.items.filter(item => item.row === row);
        if (selectedItem.length > 0) {
            this.setState({
                selected: selectedItem[0].details,
            });
        }
    };

    render() {
        return (
            <div className={styles.twoColumnInspector}>
                <div className={styles.itemList}>
                    <DetailsList
                        columns={this.props.columns}
                        items={this.props.items.map(item => item.row)}
                        checkboxVisibility={CheckboxVisibility.hidden}
                        onActiveItemChanged={this.changeSelected}
                    />
                </div>
                <div className={styles.itemDetails}>
                    <DiagnosticsInspector target={this.state.selected} />
                </div>
            </div>
        );
    }
}
